var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasmatiRice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004137;}\n\t.st1{fill:#F1D6A2;}\n\t.st2{fill:#FFE7BE;}\n\t.st3{fill:#EBC278;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 104.96,
    cy: 145.34,
    rx: 32.66,
    ry: 7.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 104.96,
    cy: 141.82,
    rx: 19.6,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.22,143.2c-4.06,3.02-16.52,5.23-31.26,5.23s-27.2-2.2-31.26-5.23c-0.91,0.68-1.4,1.39-1.4,2.14 c0,4.07,14.62,7.36,32.66,7.36s32.66-3.3,32.66-7.36C137.62,144.6,137.12,143.88,136.22,143.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9023 -0.431 0.431 0.9023 -36.3004 70.9787)",
    className: "st1",
    cx: 138.48,
    cy: 115.6,
    rx: 32.66,
    ry: 7.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9023 -0.431 0.431 0.9023 -35.0787 70.014)",
    className: "st2",
    cx: 136.96,
    cy: 112.42,
    rx: 19.6,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.77,100.19c-2.36,4.48-12.65,11.84-25.95,18.19c-13.3,6.35-25.49,9.73-30.46,8.76 c-0.53,1-0.66,1.86-0.34,2.53c1.75,3.67,16.37,0.34,32.65-7.43c16.28-7.77,28.05-17.05,26.3-20.72 C167.63,100.85,166.88,100.41,165.77,100.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4656 -0.885 0.885 0.4656 -51.0251 121.79)",
    className: "st1",
    cx: 75.33,
    cy: 103.14,
    rx: 7.36,
    ry: 32.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4656 -0.885 0.885 0.4656 -47.3899 121.5752)",
    className: "st2",
    cx: 76.97,
    cy: 100.03,
    rx: 1.92,
    ry: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.99,115.8c-5,0.79-17.05-3.06-30.1-9.93C60.84,99.01,50.84,91.27,48.66,86.7 c-1.12,0.18-1.89,0.58-2.24,1.24c-1.89,3.6,9.51,13.33,25.48,21.72s30.44,12.29,32.33,8.69 C104.58,117.69,104.48,116.83,103.99,115.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1039 0.1039 0.9946 -8.3652 14.3953)",
    className: "st1",
    cx: 134.02,
    cy: 87.51,
    rx: 32.66,
    ry: 7.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1039 0.1039 0.9946 -8.0032 14.3384)",
    className: "st2",
    cx: 133.65,
    cy: 84,
    rx: 19.6,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.88,82.13c-3.73,3.43-15.89,6.91-30.55,8.45s-27.28,0.63-31.63-1.95c-0.83,0.77-1.25,1.53-1.17,2.27 c0.42,4.05,15.31,5.81,33.25,3.93c17.94-1.87,32.14-6.67,31.72-10.72C166.42,83.37,165.86,82.71,164.88,82.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0869 0.0869 0.9962 -5.5606 8.5884)",
    className: "st1",
    cx: 95.83,
    cy: 68.14,
    rx: 32.66,
    ry: 7.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0869 0.0869 0.9962 -5.2568 8.5485)",
    className: "st2",
    cx: 95.53,
    cy: 64.63,
    rx: 19.6,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.79,63.29c-3.78,3.37-16,6.64-30.69,7.92c-14.68,1.28-27.28,0.17-31.59-2.49 c-0.85,0.75-1.28,1.51-1.21,2.25c0.35,4.05,15.21,6.07,33.18,4.5c17.97-1.57,32.25-6.12,31.9-10.18 C128.3,64.56,127.75,63.89,126.79,63.29z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasmatiRice);
export default __webpack_public_path__ + "static/media/Basmati_rice.748c04456667a1da401e3dcec59c48de.svg";
export { ForwardRef as ReactComponent };